// @flow
import React, { useEffect, useRef, useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
    root: {
        // color: '#52af77',
        height: 8
    },
    thumb: {
        height: 18,
        width: 10,
        borderRadius: 0,
        marginTop: -5
    },
    active: {},
    valueLabel: {
        left: 'calc(-50% + 4px)'
    },
    track: {
        height: 8,
        borderRadius: 0
    },
    rail: {
        height: 8,
        borderRadius: 0
    }
});

type Props = $ReadOnly<{
    value: number,

    onMouseDown?: (e: SyntheticMouseEvent) => void,
    onChange?: (e: SyntheticEvent, newValue: number) => void,
    onMouseUp?: (e: SyntheticMouseEvent) => void
}>;
function Timeline({ value, onMouseDown, onChange, onMouseUp }: Props) {
    const classes = useStyles();
    const trackingRef = useRef(false);

    const handleMouseDown = (e) => {
        if(onMouseDown) {
            onMouseDown(e);
        }

        trackingRef.current = true;
    };

    const handleChange = (e, newValue) => onChange(e, newValue);

    const handleMouseUp = useCallback((e) => {
        if(onMouseUp && trackingRef.current) {
            onMouseUp(e);
        }

        trackingRef.current = false;
    }, [onMouseUp]);

    useEffect(() => {
        document.addEventListener('mouseup', handleMouseUp);

        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [handleMouseUp]);

    return (
        <Slider
            value={value}
            classes={classes}
            onMouseDown={handleMouseDown}
            onChange={handleChange}
            onMouseUp={handleMouseUp}
        />
    );
}

export default Timeline;